import {Injectable} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {Store} from '@ngrx/store';
import {UserTimezone} from 'app/main/signing-pages/signing-page/signing-page.dto';
import {map} from 'rxjs';
import {DocumentTypeData} from '../../../pages/documents/dto/contract-data.dto';
import {ActivityLogs} from '../../../signing-pages/signing-sidebar/activity-logs/activity-logs-dto';
import * as sharedStoreActions from './shared-store.action';
import * as SharedStoreSelector from './shared-store.selector';

@Injectable({
    providedIn: 'root'
})

export class SharedStoreFacade {
    
    public activities$ = this._store$.select(SharedStoreSelector.activities);
    public activitiesLoader$ = this._store$.select(SharedStoreSelector.activitiesLoader);
    public sendInternalChatFormLoader$ = this._store$.select(SharedStoreSelector.sendInternalChatFormLoader);
    public users$ = this._store$.select(SharedStoreSelector.users);
    public documentTypes$ = this._store$.select(SharedStoreSelector.documentTypes);
    public filterDocumentTypes$ = this._store$.select(SharedStoreSelector.documentTypes).pipe(
        map(documentTypes => [
            {
                created_at: null,
                document_type: this._translocoService.translate('Filter default selected item - (general) - All'),
                id: null,
                is_default: false,
                updated_at: '',
                user_id: 0,
                workspace_id: 0
            },
            ...documentTypes
        ])
    );
    public isDocumentTypesLoading$ = this._store$.select(SharedStoreSelector.isDocumentTypesLoading);
    public userTimezone$ = this._store$.select(SharedStoreSelector.userTimezone);

    constructor (private _store$: Store, private _translocoService: TranslocoService) {}


    saveUserTimezone(userTimezone: UserTimezone){
        this._store$.dispatch(sharedStoreActions.saveUserTimeZoneSetting(userTimezone))
    }


    fetchRecipientActivties(roleId: number) {
        this._store$.dispatch(sharedStoreActions.fetchRecipientActivities(roleId))
    }



    fetchDocumentActivities(documentId: number){
        this._store$.dispatch(sharedStoreActions.fetchDocumentActivities(documentId));
    }


    updateMessage(message: ActivityLogs){
        this._store$.dispatch(sharedStoreActions.updateMessages(message));
    }


    sendInternalMessage(documentId: number, formData: FormData){
        this._store$.dispatch(sharedStoreActions.sendInternalMessage(documentId, formData));
    }


    fetchSubUsers(){
        this._store$.dispatch(sharedStoreActions.fetchSubUsers());
    }



    updateRecipientActivityStatus(roleId: number, activityIds: number[]){
        this._store$.dispatch(sharedStoreActions.updateRecipientActivityStatus(roleId, activityIds))
    }
    
    
    updateDocumentActivityStatus(roleId: number, activityIds: number[]){
        this._store$.dispatch(sharedStoreActions.updateDocumentActivityStatus(roleId, activityIds))
    }


    getDocumentTypes(){
        this._store$.dispatch(sharedStoreActions.fetchDocumentTypes());
    }
    
    updateDocumentTypesList( documentTypes: DocumentTypeData []):void{
        this._store$.dispatch(sharedStoreActions.updateDocumentTypesList({documentTypes:documentTypes}));
    }

}
